export default __webpack_public_path__ + "terrain-map-500-462a741911e2c3f03be0bad34a5ca42e.webp";